import { Component, inject } from '@angular/core';
import { HeaderService } from 'src/app/core/services/header/header.service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  standalone: false,
})
export class AppLayoutComponent {
  private headerService = inject(HeaderService);

  constructor() {
    this.headerService.showNav();
  }
}
